// Question visibility — canon Phase 4 / rule 17.
// IntersectionObserver distinguishes "shown in viewport" from "rendered but not
// visible" → drives question_view and seen/not-seen. Fires once per element.
export interface VisibilityTracker {
  observe(element: Element, onVisible: () => void): void;
  disconnect(): void;
}

export function createVisibilityTracker(threshold = 0.5): VisibilityTracker {
  if (typeof IntersectionObserver === 'undefined') {
    // Fallback: no IO → treat as visible immediately (best effort).
    return {
      observe(_element, onVisible) {
        onVisible();
      },
      disconnect() {
        /* noop */
      },
    };
  }

  const handlers = new WeakMap<Element, () => void>();
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
          const handler = handlers.get(entry.target);
          if (handler) {
            handler();
            io.unobserve(entry.target);
            handlers.delete(entry.target);
          }
        }
      }
    },
    { threshold },
  );

  return {
    observe(element, onVisible) {
      handlers.set(element, onVisible);
      io.observe(element);
    },
    disconnect() {
      io.disconnect();
    },
  };
}
